export {AgendaModule} from './core/agenda.module';
export {AgendaService} from './core/agenda.service';
